<template>
  <FlexCol gap-1>
    <Flex justify-between gap-3>
      <div>
        <Label :label="label" :required="required" :error="error" v-if="label" />
      </div>
      <Flex center gap-2 class="hidden">
        <Pill v-if="min">Min: {{ min }}</Pill>
        <Pill v-if="max">Max: {{ max }}</Pill>
      </Flex>
    </Flex>
    <Input
      v-model="localValue"
      :error="error || forceError"
      :placeholder="props.placeholder"
      :disabled="props.disabled"
      number
      :min="props.min"
      :max="props.max"
      :dense="props.dense">
    </Input>
    <Error :message="error" v-if="error" />
  </FlexCol>
</template>

<script setup>
import { watch, ref } from 'vue'

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  forceError: Boolean,
  error: Array,
  modelValue: [String, Number],
  placeholder: String,
  min: String,
  max: String,
  dense: Boolean,
  integer: Boolean,
})

const emits = defineEmits(['update:modelValue'])
const localValue = ref(props.modelValue)
const error = ref(props.error)

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  }
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  }
)

watch(localValue, (newValue) => {
  if (props.integer && newValue !== null && newValue !== undefined && newValue !== '') {
    const intValue = parseInt(newValue, 10)
    emits('update:modelValue', isNaN(intValue) ? newValue : intValue)
  } else {
    emits('update:modelValue', newValue)
  }
})
</script>
